import { Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { IAccesso } from '../interfaces/IAccesso';
import * as Enum from '../utils/enums';
import * as Moment from 'moment';
import * as Constants from '../utils/constants';
import { RequestBuilder } from '../classes/request-builder';
import { AccessiService } from '../services/accessi.service';
import { ICantiere } from '../interfaces/ICantiere';
import { AlertUtil } from '../utils/alert-util';
import { Loading } from '../utils/loading';
import { finalize } from 'rxjs/operators';


@Component({
  selector: 'app-accessi-modal',
  templateUrl: './accessi-modal.component.html',
  styleUrls: ['./accessi-modal.component.css'],
})
export class AccessiModalComponent implements OnInit {
  /**
   * Dati che arrivano da accessi
   */
  accessi: IAccesso[]; // Array di tutti gli accessi (effettuati e programmati)
  parent: any; // Oggetto mezzo o persona, parent degli accessi
  parentType: string; // Stringa con il tipo di parent degli accessi (mezzo o persona)
  cantiereSelected: ICantiere; // Cantiere selezionato
  siti: any; // Siti di accesso per il cantiere selezionato

  isPrefettura: boolean = false; // Determines whether the user logged is 'Prefettura'
  isReferente: boolean = false;  // Determines whether the user logged is 'Referente'
  isAdmin: boolean = false;  // Determines whether the user logged is 'Admin'
  isAffidatario: boolean = false;  // Determines whether the user logged is 'Affidatario'
  isCSE: boolean = false;  // Determines whether the user logged is 'CSE'


  /**
   * Array usati per popolare le tabelle
   */
  accessiProgrammati: any[];
  accessiEffettuati: any[];

  /**
   * Calendario
   */
  it: any; // Lingua del calendario
  dates: Date[]; // Array di date selezionate nel Calendar
  accessiProgrammatiDate: Date[]; // Array di date per i soli accessi programmati usato nel calendario
  accessiEffettuatiDate: Date[]; // Array di date per i soli accessi effettuati usato nel calendario
  disabledDates: Date[]; // Array di date degli accessi effettati disabilitate per la visualizzazione dei programmati

  disableSave = false; // Booleano che abilita/disabilita il pulsante per salvare gli accessi

  DTTM = Enum.DATA_TABLE_TYPE_ENUM; // enum per html
  L = Loading; // export loading for html

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private accessiService: AccessiService,
    private alertUtil: AlertUtil
  ) { }

  ngOnInit() {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE);
    if (
      userRole == Enum.USER_TYPE_ENUM.PREFETTURA ||
      userRole == Enum.USER_TYPE_ENUM.DL
    ) {
      this.isPrefettura = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.REFERENTE) {
      this.isReferente = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO) {
      this.isAffidatario = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.isAdmin = true;
    } else if (userRole == Enum.USER_TYPE_ENUM.CSE){
      this.isCSE = true
    }

    /**
     * Lingua italiana nel calendario
     */
    this.it = {
      firstDayOfWeek: 1,
      dayNames: [
        'Domenica',
        'Lunedì',
        'Martedì',
        'Mercoledì',
        'Giovedì',
        'Venerdì',
        'Sabato',
      ],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
      monthNames: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
      ],
      monthNamesShort: [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic',
      ],
      today: 'Oggi',
      clear: 'Cancella',
    };

    this.disableSave = this.checkToDisabledButton();

    /**
     * Inizializzazione Array
     */
    this.disabledDates = [];

    /**
     * Oggetto e tipo del parent degli accessi (mezzo o persona) e cantiere selezionato
     */
    this.parent = this.config.data.parent;
    this.parentType = this.config.data.parentType;
    this.siti = this.config.data.siti;
    this.cantiereSelected = this.config.data.cantiereSelected;

    /**
     * Popolamento array di accessi e date per gli accessi programmati ed effettuati
     * usati nella tabella (accessi) e nella selezione delle date nel calendario (date)
     */
    this.accessi = this.config.data.data.Accessi;

    this.validaAccessiProgrammatiEffettuati(this.accessi);

    /**
     * Di default nel calendario vengono selezionate le date degli accessi programmati
     * Modifica del 29/11/2024 - Aggiunto controllo su popolamento array per evitare errore nella libreira p-calendar
     */
    if(this.accessiProgrammatiDate.length > 0) {
      this.dates = this.accessiProgrammatiDate;
      this.sortDates();
    }

    this.disabledDates = this.accessiEffettuatiDate;
    
  }

  /**
   * Popola gli array di 'accessiEffettuati' e 'accessiProgrammati'
   * @param accessi
   */
  validaAccessiProgrammatiEffettuati(accessi: IAccesso[]) {
    this.accessiEffettuati = [];
    this.accessiProgrammati = [];
    this.accessiEffettuatiDate = [];
    this.accessiProgrammatiDate = [];

    accessi.forEach((accesso) => {
      //Creazione oggetti Date
      let accessoMoment = Moment(accesso.Data);
      let accessoDate = accessoMoment.toDate();

      // Valorizzo il Riferimento in base al parentiType
      this.setRiferimento(accesso);

      if (accesso.Effettuato) {
        //Data per la tabella degli accessi effettuati che deve avere l'orario
        let valueMoment = Moment(accesso.Data, 'YYYY-MM-DDTHH:mm:ss', true);
        if (valueMoment.isValid()) {
          accesso.Data = valueMoment.format('DD/MM/YYYY HH:mm:ss');
        }

        // Valorizzo il tipo in base al parentiType
        this.setTipo(accesso);

        this.accessiEffettuati.push(accesso);
        this.accessiEffettuatiDate.push(accessoDate);
      } else {
        this.accessiProgrammati.push(accesso);
        this.accessiProgrammatiDate.push(accessoDate);
      }
      accesso.Coordinate = accesso.Latitudine + ' ' + accesso.Longitudine;
    });

    this.accessiProgrammati.sort(this.sortAccessiArray());
    this.accessiEffettuati.sort(this.sortAccessiArray());
  }

  private setRiferimento(accesso: IAccesso) {
    if (this.parentType === Enum.DATA_TABLE_TYPE_ENUM.PERSONA) {
      accesso['Riferimento'] = this.parent.Cognome + ' ' + this.parent.Nome;
    } else {
      accesso['Riferimento'] = this.parent.Marca + ' - ' + this.parent.Modello;
    }
  }

  private setTipo(accesso: IAccesso) {
    if (this.parentType === Enum.DATA_TABLE_TYPE_ENUM.PERSONA) {
      accesso['Tipo'] =
        accesso['Tipo'] + ' ' + this.parent.Cognome + ' ' + this.parent.Nome;
    } else {
      accesso['Tipo'] =
        accesso['Tipo'] +
        ' ' +
        '(' +
        this.parent.Marca +
        ' - ' +
        this.parent.Modello +
        ')';
    }
  }

  /**
   * Selezione di un tab panel
   * @param event
   */
  handleChange(event: any) {
    this.dates = [];
    // Indice del tab panel selezionato
    let index = event.index;
    if (index == 0) {
      // Selezionato il pannello degli accessi programmati
      this.disableSave = this.checkToDisabledButton();
      this.dates = this.accessiProgrammatiDate;
      this.disabledDates = this.accessiEffettuatiDate;
    } else {
      // Selezionato il pannello degli accessi effettuati
      this.disableSave = true;
      this.dates = this.accessiEffettuatiDate;
      this.disabledDates = [];
    }
    this.sortDates();
  }

  /**
   * Click sul salvataggio degli accessi programmati
   */
  saveAccessi() {
    Loading.isLoading = true;
    // Array di accessi programmati
    let accessesForSaving: IAccesso[] = [];

    this.dates.forEach((date) => {
      // data con formato YYYY-MM-DDTHH:mm:ss per il salvataggio
      let dateInString = Moment(date).format('YYYY-MM-DDTHH:mm:ss');

      //Creazione accesso
      let accesso: IAccesso = {
        Codice: '',
        Data: dateInString,
        Effettuato: false,
        Tipo: '',
        Persona: null,
        Mezzo: null,
        Cantiere: null,
        Latitudine: null,
        Longitudine: null,
        Coordinate: null,
        sito: null,
      };

      //Set dei campi e dell'oggetto all'interno dell'accesso a seconda che sia persona oppure mezzo
      if (this.parentType == Enum.DATA_TABLE_TYPE_ENUM.PERSONA) {
        //Persona
        accesso.Persona = this.parent;
        accesso.Codice = accesso.Persona.Codice_fiscale;

        //Mansione se c'e' altrimenti qualifica
        let tipo = accesso.Persona.Mansione
          ? accesso.Persona.Mansione
          : accesso.Persona.Qualifica;
        accesso.Tipo = tipo;
      } else {
        //Mezzo
        accesso.Mezzo = this.parent;
        accesso.Codice = accesso.Mezzo.Targa;

        //Tipo se c'e' altrimenti definizione
        let tipo = accesso.Mezzo.Tipo
          ? accesso.Mezzo.Tipo
          : accesso.Mezzo.Definizione;
        accesso.Tipo = tipo;
      }

      //set dell'oggetto cantiere selezionato all'interno dell'accesso
      accesso.Cantiere = this.cantiereSelected;

      this.accessiProgrammati.forEach((item) => {
        let dataAccessoApp = accesso.Data;
        let dataItemApp = item.Data;

        let dataAccesso = Moment(dataAccessoApp, 'YYYY-MM-DD');
        let dataItem = Moment(dataItemApp, 'YYYY-MM-DD');
        if (dataAccesso.isSame(dataItem)) {
          accesso.sito = item.sito;
        }
      });
      accesso.Data = Moment(accesso.Data).format();

      //Inserimento dell'accesso nell'array da passare al servizio
      accessesForSaving.push(accesso);
    });

    //Creazione della richiesta
    let requestBuilder = new RequestBuilder(
      {
        Accessi: accessesForSaving,
        IdCantiere: this.cantiereSelected.Id,
        Id: this.parent.Id,
        Type: this.parentType, //mezzo o persona
      },
      [
        'Cantiere',
        this.parentType.charAt(0).toUpperCase() + this.parentType.slice(1),
      ]
    );

    this.accessiService
      .saveAllAccessi(requestBuilder)
      .pipe(
        finalize(() => {
          Loading.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          if (response.data) {
            this.alertUtil.showAlert(
              'LBL_ACCESSI_SAVE_SUCCESS',
              null,
              null,
              null,
              () => {
                this.ref.close();
              }
            );
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
              error: response.Message,
            });
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }


  /**
   * get actual day at moment of login
   * and disabled button from friday after 14:00 at Monday before 7:00
   */
  checkToDisabledButton(): boolean {
    let isDisabled = false;
    let dayWhenDisabled: number[] = [0, 1, 5, 6]; //array of index (days Moment) when disabled button
    let actualDate = Moment(); //actual date
    if (dayWhenDisabled.includes(actualDate.day())) {
      //if today as icludes in array
      if (
        (actualDate.day() == 5 && actualDate.hour() < Constants.ACCESSI_BLOCK.START) ||
        (actualDate.day() == 1 && actualDate.hour() > Constants.ACCESSI_BLOCK.END)
      ) {
        isDisabled = false;
      } else {
        isDisabled = true;
      }
    }
    return isDisabled;
  }

  /**
   * sort dates descending
   */
  private sortDates() {
    this.dates.sort((date1, date2) => {
      return date1 > date2 ? -1 : 1;
    });
  }

  onModificaSito(accesso: IAccesso) {
    this.accessiProgrammati.forEach((item) => {
      if (accesso.Id == item.Id) {
        item.sito = accesso.sito;
      }
    });
  }


  onValidaAccesso(accesso: IAccesso) {
    this.alertUtil.showConfirmationAlert("LBL_ALERT_VALIDATION_ACCESSO", null, "LBL_VALIDATION_ACCESSO_HD", null, null, () => {
      // Implementa il passaggio da accessoProgrammato a accessoEffettuato
      accesso.Effettuato = true;
      accesso.Latitudine = '';
      accesso.Longitudine = '';

      this.callSaveIngressoAccessi(accesso);
    });
  }

  /**
   * Chiama l'API del servizio per salvare l'accesso effettuato
   * @param accesso acesso effettuato
   */
  private callSaveIngressoAccessi(accesso: IAccesso) {
    let listAccessi: IAccesso[] = [];
    listAccessi.push(accesso);

    let reqBuilder = new RequestBuilder({
      Accessi: listAccessi
    });

    this.accessiService.saveIngressoAccessi(reqBuilder).pipe(
      finalize(() => {
        Loading.isLoading = false;
      })
    )
      .subscribe(
        (response) => {
          if (response.data) {
            this.alertUtil.showAlert(
              'LBL_ACCESSI_SAVE_SUCCESS',
              null,
              null,
              null,
              () => {
                this.ref.close();
              }
            );
          } else if (response.error) {
            let errorKey = 'LBL_ERROR_' + response.error.Code;
            this.alertUtil.showErrorAlert(errorKey);
            console.log('ERROR: ' + response.error.Stack);
          } else {
            this.alertUtil.showErrorAlert('LBL_SERVER_ERROR_GENERIC', {
              error: response.Message,
            });
          }
        },
        (error) => {
          let errorKey = 'LBL_HTTP_ERROR_0';
          if (error.status) {
            errorKey = 'LBL_HTTP_ERROR_' + error.status;
          }
          this.alertUtil.showErrorAlert(errorKey);
        }
      );
  }

  /**
* sort accessi array by data 
*/
  private sortAccessiArray(): (a: IAccesso, b: IAccesso) => number {
    return (a: IAccesso, b: IAccesso) =>
      new Date(a.Data) < new Date(b.Data) ? -1 : 1;
  }
}
